import request from '../utils/Request';
import { Methods } from '../config';
import { endSession, getSessionGeneration, redirectToLogin, startSession } from '../utils/authSession';

const baseURL = 'auth';
let logoutPromise = null;

const authService = {
  login: async (data) => {
    startSession();
    const resp = await request({
      method: Methods.POST,
      resource: `${baseURL}/login`,
      data,
    });
    if (resp.token) {
      delete resp.token;
    }
    return resp;
  },
  logout: () => {
    if (logoutPromise) return logoutPromise;
    const token = localStorage.getItem('token');
    endSession();
    const generation = getSessionGeneration();
    logoutPromise = request({
      method: Methods.POST,
      resource: `${baseURL}/logout`,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      timeout: 10000,
    }).finally(() => {
      if (getSessionGeneration() === generation) {
        if (!localStorage.getItem('token')) endSession();
        redirectToLogin();
      }
    });
    return logoutPromise;
  },
};

export default authService;
